import React from 'react';
import './cardGrid.scss';

const CardGrid = ({ content } ) => {
    if (content) {
        return (
        <div className={'card_grid'}>
        {
            Object.keys(content).map((item) => {
                return (
                <div key={item} className={'card'} style={{
                    backgroundColor: `${content[item].backgroundColor}`,
                    color: `${content[item].color}`}}
                >
                    <ImageContainer
                        image={content[item].image}
                        alt={content[item].title}
                    />
                    <div className="conteint">
                        <span className={"extra-bold"}>{content[item].title} </span>
                        <span>{content[item].description}</span>
                    </div>
                </div>
                )
            })
        }
        </div>
        )
    }
    return null;
};

const ImageContainer = ({image, alt}) => {
    return (
        <div className="image_border">
            <img src={image} alt={alt} />
        </div>
    )
}

export default CardGrid;